<template>
  <div class="impressum-layout animated fadeIn" v-html="$t('Webportal.DataProtection.Content')">
  </div>
</template>

<script>
export default {
  name: 'DataProtection'
}
</script>

<style lang="scss" scoped>
  h5 {
    margin-top:1em
  }
  a {
    color: var(--color-primary);
  }
  a:hover {
    color: var(--color-primary);
  }
</style>
